import React, { FormEvent, ReactNode } from 'react';
import InputBlock from '../../../components/connectedForm/InputBlock';
import InputGroup from '../../../components/connectedForm/InputGroup';
import InputLabel from '../../../components/connectedForm/InputLabel';
import InputErrorMessage from '../../../components/connectedForm/InputErrorMessage';
import Toggle from '../Toggle/Toggle';

export type IToggleInputProps = {
  dataid?: string;
  active?: boolean;
  id?: string;
  label?: string;
  includeLabel?: boolean;
  flexBox?: boolean;
  inputCols?: string | number;
  labelCols?: string | number;
  readOnly?: boolean;
  hint?: ReactNode;
  value: boolean;
  showWhenNotActive?: boolean;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
  onChange?: (value: boolean) => void;

  touched?: any;
  tabIndex?: any;
  testId?: string;
  validationErrors?: Array<any> | any;
  customValidationErrors?: Array<any> | any;
};

const ToggleInput = ({
  dataid,
  active,
  id,
  label,
  includeLabel,
  flexBox,
  inputCols,
  labelCols,
  readOnly,
  hint,
  value,
  showWhenNotActive,
  onBlur,
  onFocus,
  onChange,

  touched,
  tabIndex,
  testId,
  validationErrors,
  customValidationErrors,
}: IToggleInputProps) => {
  const labelProps = {
    flexBox,
    id,
    includeLabel,
    hint,
    label,
    readOnly,
  };
  return (
    <InputBlock flexBox={flexBox}>
      <InputLabel {...labelProps} cols={labelCols} />
      <InputGroup flexBox={flexBox} cols={inputCols} withLabel={includeLabel}>
        <Toggle
          id={id}
          testId={testId}
          onBlur={onBlur}
          onChange={onChange}
          onFocus={onFocus}
          value={value}
          tabIndex={tabIndex}
        />
        <InputErrorMessage
          label={label}
          active={active}
          touched={touched}
          validationErrors={validationErrors}
          showWhenNotActive={showWhenNotActive}
          customValidationErrors={customValidationErrors}
        />
      </InputGroup>
    </InputBlock>
  );
};

ToggleInput.defaultProps = {
  active: false,
  mandatory: false,
  onBlur: () => {},
  onFocus: () => {},
  onChange: () => {},
  includeLabel: true,
  readOnly: false,
  flexBox: true,
  labelCols: 1 / 4,
  inputCols: 3 / 4,
  value: false,
  message: [],
  hint: '',
  showWhenNotActive: false,
  label: '',
  id: '',
};

export default ToggleInput;
